import React from 'react';
import FileTreeNode from './FileTreeNode';
import DiscrepancyFileTreeNode from './DiscrepancyFileTreeNode';

const FileDirectoryTree = (props) => {
  const { files, toggleSelect, isTimelineEntry, isDiscrepancyEntry } = props;

  const TreeNodeComponent = isDiscrepancyEntry ? DiscrepancyFileTreeNode : FileTreeNode;

  return (
    <div className="file-directory-tree">
      {Object.entries(files)?.map(([key, node]) => (
        <TreeNodeComponent
          key={node?.file_id || key}
          node={{ display_name: key, ...node }}
          toggleSelect={toggleSelect}
          isTimelineEntry={isTimelineEntry}
        />
      ))}
    </div>
  );
};

export default FileDirectoryTree;
